
import WidgetDefaultNuxt from '../default/nuxt.vue';

export default {
  name: 'WidgetAudioNuxt',
  extends: WidgetDefaultNuxt,
  data() {
    let src = this.values.audio?.src;
    let loop = this.values.audio?.loop;
    let autoplay = this.values.audio?.autoplay ?? true;
    return {
      isTriggerReady: false,
      widgetClassName: 'widget-audio',
      src: this.getLocaleValue(src) ?? '',
      localePath: [{ key: 'src', value: src }],
      duration: 0,
      loop,
      autoplay,
    };
  },
  computed: {
    widgetListener() {
      if (this.staticEvent) return this.$listeners;
      return {
        ...this.$listeners,
        click: this.onClick,
      };
    },
  },
  methods: {
    initEvent() {
      this.rocketOn('rocket:audio:play', true, () => {
        if (!this.isPlay) this.play();
      });
      this.rocketOn('rocket:audio:re-play', true, () => {
        this.rePlay();
      });
      this.rocketOn('rocket:audio:pause', true, () => {
        if (this.isPlay) this.stop();
      });
      this.rocketOn('rocket:audio:toggle', true, () => {
        this.handleTogglePlay();
      });
      this.rocketOn('rocket:audio:seek', true, (s) => {
        this.seek(s);
      });
    },
    handlePlaying() {
      this.isPlay = true;
      this.rocketEmit('rocket:audio:playing', true);
    },
    handlePaused() {
      this.isPlay = false;
      this.rocketEmit('rocket:audio:paused', true);
    },
    handleEnd() {
      this.isPlay = false;
      this.rocketEmit('rocket:audio:ended', true);
    },
    play() {
      this.$refs.audio
        .play()
        .then((event) => {
          this.$nextTick(() => {
            this.isTriggerReady = true;
          });
        })
        .catch((data) => {
          if (data.code === 9) {
            console.log('加载失败，因为没有找到支持的源。');
          }
        });
    },
    rePlay() {
      this.$refs.audio.currentTime = 0;
      this.$refs.audio
        .play()
        .then((event) => {
          this.$nextTick(() => {
            this.isTriggerReady = true;
          });
        })
        .catch((data) => {
          if (data.code === 9) {
            console.log('加载失败，因为没有找到支持的源。');
          }
        });
    },
    stop() {
      this.$refs.audio.pause();
    },
    seek(s) {
      if (!this.duration) {
        this.duration = this.$refs.audio.duration || 0;
      }

      let second = s;
      if (s <= 0) {
        second = 0;
      } else if (s >= this.duration) {
        second = this.duration;
      }
      this.$refs.audio.currentTime = second;
    },
    onClick(e) {
      this.handleTap(e);
      this.onClickAudio();
    },
    handleTogglePlay() {
      if (!this.isPlay) {
        this.play();
      } else {
        this.stop();
      }
    },
  },
};
